module.exports = function (property) {
  return displayPrice(property);
};

function displayPrice(property) {
  if (
    property.property.price_buy !== "0" &&
    property.property.price_rent !== "0"
  )
    return `${numberFormat(property.property.price_buy)} or ${numberFormat(
      property.property.price_rent
    )}/${property.property.price_rent_per}`;
  else if (
    property.property.price_buy !== "0" &&
    property.property.price_rent === "0"
  )
    return numberFormat(property.property.price_buy);
  else
    return `${numberFormat(property.property.price_rent)}/${
      property.property.price_rent_per
    }`;
}

function numberFormat(number) {
  return new Intl.NumberFormat().format(number);
}
